import { render, staticRenderFns } from "./DeviceScreenSetting.vue?vue&type=template&id=6ed6a9ca&"
import script from "./DeviceScreenSetting.vue?vue&type=script&lang=js&"
export * from "./DeviceScreenSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports